import { toast } from "react-toastify";
import { apiURL } from "../../config";

/** Platform administration (root only): organizations and their organization admins. */
export async function getOrganizations(axiosPrivate) {
	return axiosPrivate.get(`${apiURL}/superadmin/organizations.json`).then((res) => res.data);
}

// Validation errors (400) are returned for the form, other errors (e.g. 409) are shown as a toast
function handleError(err, message) {
	if (err.response?.status !== 400) toast.error(err.response?.data?.message || message);
	return err.response;
}

/** data: { name, admin: { firstName, lastName, email, password } } */
export async function createOrganization(axiosPrivate, data) {
	return axiosPrivate
		.post(`${apiURL}/superadmin/organizations.json`, data)
		.then((res) => {
			toast.success("Organization created");
			return res;
		})
		.catch((err) => handleError(err, "Could not create the organization. Please try again."));
}

/** data: { firstName, lastName, email, password } */
export async function addOrganizationAdmin(axiosPrivate, organizationId, data) {
	return axiosPrivate
		.post(`${apiURL}/superadmin/organizations/${organizationId}/admins.json`, data)
		.then((res) => {
			toast.success("Organization admin added");
			return res;
		})
		.catch((err) => handleError(err, "Could not add the organization admin. Please try again."));
}
